import React, { useState, useEffect } from "react";
import bannerTop from "../../../Images/Product & Services/HardwareS/hard-bg.png";
import lowerBg from "../../../Images/Product & Services/HardwareS/lowerBG.png";
import { Parallax } from "react-parallax";
import "./HardwareSolution.css";
import { faFileArrowDown, faPhone } from "@fortawesome/free-solid-svg-icons";
import hardLottie from "./hard-solution.json";
import Slider from "react-slick";
import hardLogoImg from "../../../Images/Product & Services/HardwareS/dell-logo.png";
import hardImg1 from "../../../Images/Product & Services/HardwareS/hardSlide1.png";
import hardImg2 from "../../../Images/Product & Services/HardwareS/hardSlide2.png";
import hardImg3 from "../../../Images/Product & Services/HardwareS/hardSlide3.png";
import Lottie from "lottie-react";
import NavigationBar from "../../Shared/NavigationBar/NavigationBar";
import Footer from "../../Shared/Footer/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const HardwareSolution = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const handleDownload = () => {
    setIsDownloading(true);
    const link = document.createElement("a");
    link.href = "/";
    link.download = "/";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setIsDownloading(false);
  };

  // Slick Slider

  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Reload 0
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavigationBar />
      <section className="hard-div-banner">
        <div>
          <img className="hard-banner" src={bannerTop} alt="" />
        </div>
      </section>
      <section className="hard-mobile-texts-div">
        <div className="software-mobile-texts">
          <div className="d-flex align-items-center text-center">
            <img src={hardLogoImg} alt="" />
            <h5 className="hard-head-tag ms-2">DELL Technologies</h5>
          </div>
          <p className="hard-p1 mt-3">
            NRB Enlisted dynamic & secure VAT Software
          </p>
          <p className="hard-p2 ">
            Dell Technologies Titanium Partnership is the highest tier in Dell's
            Partner Program, designed to recognize partners who have achieved a
            significant level of expertise in delivering Dell's products and
            solutions to their customers. The Titanium tier offers partners
            access to a range of benefits, including dedicated account support,
            early access to new products and technologies, and marketing and
            business development resources. The Titanium tier is designed to
            help partners grow their business and increase their profitability
            by providing them with the tools and support they need to deliver
            exceptional customer experiences. To become a Dell Technologies
            Titanium Partner, a company must meet stringent requirements, such
            as revenue targets, certifications, and customer satisfaction
            metrics, and demonstrate a deep understanding of Dell's products and
            solutions. Pakiza Technovation Ltd. (A sister concern of PAKIZA
            GROUP) became it’s TITANIUM partner since 2021
          </p>
        </div>
      </section>
      <section className="hard-texts-div">
        <div className="software-mobile-texts">
          <div className="d-flex align-items-center text-center">
            <img src={hardLogoImg} alt="" />
            <h5 className="hard-head-tag ms-2">DELL Technologies</h5>
          </div>
          <p className="hard-p1">
            A proud <span className="hard-titanum">TITANIUM</span> partner of
            DELL
          </p>
          <p className="hard-p2">
            Cripton VAT (Value-Added Tax) software is a computer program
            designed to help businesses calculate, manage and file VAT returns
            to the relevant tax authorities. The software automates the process
            of VAT calculation and helps businesses comply with the VAT
            regulations in their country. It can handle multiple VAT rates,
            manage invoices and receipts, and provide detailed reports to
            support VAT returns. Cripton VAT software can also integrate with
            accounting and bookkeeping systems to provide a comprehensive
            solution for VAT management. By using VAT software, businesses can
            save time, reduce errors and ensure they meet their VAT obligations
            in a timely manner .
          </p>
        </div>
        <div className="hard-buttons">
          <button
            className="hard-download-file-soft"
            Click={handleDownload}
            disabled={isDownloading}
          >
            {" "}
            <span className="me-2">
              <FontAwesomeIcon icon={faFileArrowDown} />
            </span>
            {isDownloading ? "Downloading..." : "Download Brochure"}
          </button>
          <button className=" ms-2 me-2 hard-button1" type="submit">
            Request a demo
          </button>
        </div>
      </section>

      <section className="container">
        <div className="hard-fe-icons-div">
          <h3 className="hard-fe-icons">Solutions</h3>
        </div>
        <div class="lottie-mobile-hard">
          <Lottie
            animationData={hardLottie}
            loop={true}
            className="lottie-mobile-hard"
          />
        </div>
        <div className="row hard-post-text-div">
          {/* <div className="col-lg-6 col-md-12 col-12 ">
            <img className="works-post-img" src={recentImg} alt="" />
          </div> */}

          <div className="hard-middle-div col-lg-6 col-md-12 col-12">
            <ul>
              <li className="hard-crip-p">
                <p>Desktop</p>
              </li>
              <li className="hard-crip-p">
                <p>Notebook</p>
              </li>
              <li className="hard-crip-p">
                <p>Workstations</p>
              </li>
              <li className="hard-crip-p">
                <p>Monitors</p>
              </li>
              <li className="hard-crip-p">
                <p>Server & Storage</p>
              </li>
              <li className="hard-crip-p">
                <p>Hyper-converged Infrastructure</p>
              </li>
              <li className="hard-crip-p">
                <p>Virtual Desktop Infrastructure</p>
              </li>
              <li className="hard-crip-p">
                <p>Networking</p>
              </li>
            </ul>
            <p className="hard-crip-p"></p>
          </div>

          <div class="col-lg-6 col-md-12 col-12">
            <Lottie
              animationData={hardLottie}
              loop={true}
              className="lottie-Software-hard"
            />
          </div>
        </div>
      </section>
      <section className="mt-5 bg-white lower-slider">
        <Slider {...settings}>
          <div className="">
            <img className="img img-fluid hard-slide" src={hardImg1} alt="" />
          </div>
          <div className="">
            <img className="img img-fluid hard-slide" src={hardImg2} alt="" />
          </div>
          <div className="">
            <img className="img img-fluid hard-slide" src={hardImg3} alt="" />
          </div>
          <div className="">
            <img className="img img-fluid hard-slide" src={hardImg2} alt="" />
          </div>
        </Slider>
      </section>

      <section>
        <div className="hard-inpu-text-div">
          <h3 className="hard-inpu-text-h3">Request a Quote</h3>
          <p className="hard-inpu-text-p">
            At nam minimum ponderum. Est audiam animal molestiae te. Ex duo
            eripuit mentitum. At nam minimum ponderum. Est audiam animal
            molestiae.
          </p>
        </div>
        <div>
          <img className="hard-lower-back-img" src={lowerBg} alt="" />
        </div>
        <div className="hard-lower-part ">
          <div className="hardware-lower-full-input-div container">
            <div className="row g-2">
              <div className="col-md">
                <div className="form-floating">
                  <input
                    type="name"
                    class="form-control"
                    id="floatingInputGrid"
                  />
                  <label for="floatingInputGrid">Your Name</label>
                </div>
              </div>
              <div className="col-md">
                <div className="form-floating">
                  <input
                    type="email"
                    className="form-control"
                    id="floatingInputGrid"
                  />
                  <label for="floatingInputGrid">Email</label>
                </div>
              </div>
            </div>
            <div className="row g-2 mt-2">
              <div className="col-md">
                <div className="form-floating">
                  <input
                    type="number"
                    className="form-control"
                    id="floatingInputGrid"
                  />
                  <label for="floatingInputGrid">Contact No</label>
                </div>
              </div>
              <div className="col-md">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="floatingInputGrid"
                  />
                  <label for="floatingSelectGrid">Company</label>
                </div>
              </div>
            </div>
            <div className="row g-2 mt-2">
              <div className="col-md">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="floatingInputGrid"
                  />
                  <label for="floatingSelectGrid">What You Need ?</label>
                </div>
              </div>
              <div className="col-md">
                <div className="form-floating">
                  <input
                    type="email"
                    class="form-control"
                    id="floatingInputGrid"
                  />
                  <label for="floatingInputGrid">Reffrence Sources</label>
                </div>
              </div>
            </div>
            <div className="form-floating mt-3">
              <textarea
                className="form-control hard-texT-area"
                placeholder="Leave a comment here"
                id="floatingTextarea"
              ></textarea>
              <label for="floatingTextarea">Your Quarries</label>
            </div>
            <div>
              <button className="hard-submit-button" type="submit">
                Submit Your Request
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="hard-footer">
        <Footer />
      </section>
    </div>
  );
};

export default HardwareSolution;

// import React from "react";
// import Footer from "../../Shared/Footer/Footer";
// import NavigationBar from "../../Shared/NavigationBar/NavigationBar";

// const SoftwareSolution = () => {
//   return (
//     <div>
//       <NavigationBar />
//       <div>
//         <h1>Hello</h1>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default SoftwareSolution;
